// constants.ts

export const NAME = 'allProjects';